import {
  CHANGE_FORM,
	SET_AUTH,
  SENDING_LOGIN_REQUEST
} from '../constants/AppConstants';

const initialState = {
  formState: {
    username: '',
    password: ''
  },
  loggedIn: false,
  currentUser: {},
  loginError: '',
  sendingLoginRequest: false
}

const objectAssign = Object.assign || require('object.assign');

export default (state = initialState, action = null) => {
  switch (action.type) {
    case CHANGE_FORM:
			return objectAssign({}, state, {
				formState: action.newState
			});
		case SET_AUTH:
      return objectAssign({}, state, {
        loggedIn: action.isLoggedIn,
        currentUser: action.currentUser,
        loginError: action.loginError
      });
    case SENDING_LOGIN_REQUEST:
      return objectAssign({}, state, {
        sendingLoginRequest: action.sending
      });
    default:
      return state;
  }
};